var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.31 31.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1251b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,2.76,28.52,14.42,42.25,28a6.72,6.72,0,0,0,1.06-3.59V6.77a6.76,6.76,0,0,0-1.35-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.92.94A6.7,6.7,0,0,0,36.54,0H6.77A6.72,6.72,0,0,0,3.09,1.1l18.22,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.19,19.91a1.35,1.35,0,0,1-.89.33,1.38,1.38,0,0,1-.89-.33L16.53,16.5,3,30a6.72,6.72,0,0,0,3.73,1.13H36.54a6.69,6.69,0,0,0,3.84-1.22L26.47,16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.15,3A6.79,6.79,0,0,0,0,6.77V24.36a6.72,6.72,0,0,0,1.13,3.72L14.5,14.72Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.dcc36b16286eccc76507a9178adac85c.svg";
export { ForwardRef as ReactComponent };